import React from 'react';
import { Box, Flex, Text, Avatar, Button, IconButton, Divider, useToast } from '@chakra-ui/react';
import { FaUserTie, FaShareAlt } from 'react-icons/fa';

const JobDetailsMainInfo = ({ job, onApplyClick }) => {
  const toast = useToast();

  const handleShare = async () => {
    try {
      const currentUrl = window.location.href;
      await navigator.clipboard.writeText(currentUrl);
      toast({
        title: "Link copied!",
        description: "Job link has been copied to clipboard",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top"
      });
    } catch (err) {
      // Fallback for browsers that don't support clipboard API
      const textArea = document.createElement('textarea');
      textArea.value = window.location.href;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      
      toast({
        title: "Link copied!",
        description: "Job link has been copied to clipboard",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top"
      });
    }
  };

  return (
  <Box
    w="100%"
    maxW="100%"
    mx="auto"
    mt={{ base: 4, md: 8 }}
    mb={{ base: 4, md: 8 }}
    bg="white"
    borderRadius="xl"
    border="1px solid #E3EAF2"
    boxShadow="sm"
    p={{ base: 3, md: 5 }}
    zIndex={10}
  >
    <Flex
      direction={{ base: 'column', md: 'row' }}
      align={{ base: 'flex-start', md: 'center' }}
      justify="space-between"
      gap={{ base: 3, md: 6 }}
      w="100%"
    >
      <Flex align="center" gap={3} flex={1} minW={0} w="100%">
        <Avatar 
          src={job.image || undefined}
          icon={!job.image ? <FaUserTie fontSize="2rem" /> : undefined}
          bgGradient="linear(to-tr, pink.400, purple.500)"
          color="white"
          size="lg"
          boxSize={{ base: '48px', md: '64px' }}
        />
        <Box minW={0}>
          <Text fontWeight="extrabold" fontSize={{ base: 'xl', md: '2xl' }} color="#222" mb={0} noOfLines={2}>{job.title}</Text>
          <Text color="gray.500" fontSize={{ base: 'sm', md: 'md' }} fontWeight="medium">{job.location} • {job.type}</Text>
        </Box>
      </Flex>
      <Flex align="center" gap={2} w={{ base: '100%', md: 'auto' }} justifyContent={{ base: 'flex-end', md: 'flex-end' }} mt={{ base: 2, md: 0 }}>
        <IconButton 
          icon={<FaShareAlt />} 
          aria-label="Share" 
          variant="ghost" 
          colorScheme="gray" 
          fontSize="lg" 
          onClick={handleShare}
          _hover={{ bg: 'gray.100' }}
        />
        <Divider orientation="vertical" h={8} mx={2} borderColor="#E3EAF2" display={{ base: 'none', md: 'block' }} />
        <Button 
          bg="#234F4E" 
          color="white" 
          borderRadius="2xl" 
          fontWeight="bold" 
          px={8} 
          size="lg" 
          _hover={{ bg: '#1B3A4B' }}
          onClick={onApplyClick}
        >
          Apply
        </Button>
      </Flex>
    </Flex>
  </Box>
);
};

export default JobDetailsMainInfo; 